import axios from "axios";

/**
 * Enterprise Base URL
 * Falls back to port 7070 (local enterprise service) if env variables are not defined.
 */
export const getEnterpriseBaseUrl = () => {
  return (
    process.env.REACT_APP_BACKEND_ENTERPRISE_URL ||
    process.env.REACT_APP_ENTERPRISE_BACKEND_URL ||
    "http://localhost:7070"
  );
};

/**
 * Retrieves the current authentication token from localStorage
 * and formats it as a Bearer token.
 */
export const getAuthToken = () => {
  return localStorage.getItem("objectId");
};

export const getAuthHeader = () => {
  const token = getAuthToken();
  if (!token) return null;
  return token.startsWith("Bearer ") ? token : `Bearer ${token}`;
};

/**
 * Configured Axios instance for Enterprise API services
 */
export const enterpriseClient = axios.create({
  baseURL: getEnterpriseBaseUrl(),
  headers: {
    "Content-Type": "application/json",
    ...(process.env.REACT_APP_API_KEY ? { "x-api-key": process.env.REACT_APP_API_KEY } : {}),
  },
});

// Request interceptor to dynamically inject the Authorization Bearer token
enterpriseClient.interceptors.request.use(
  (config) => {
    // Dynamically re-check baseURL in case of environment changes
    if (!config.baseURL) {
      config.baseURL = getEnterpriseBaseUrl();
    }

    if (!config.headers.Authorization) {
      const authHeader = getAuthHeader();
      if (authHeader) {
        config.headers.Authorization = authHeader;
      }
    }

    if (process.env.REACT_APP_API_KEY && !config.headers["x-api-key"]) {
      config.headers["x-api-key"] = process.env.REACT_APP_API_KEY;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to normalize error handling
enterpriseClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Enterprise API Error:", error?.response || error);
    const responseError = error?.response?.data || {
      message: error?.message || "An unexpected error occurred during the enterprise API request",
    };
    return Promise.reject(responseError);
  }
);

export default enterpriseClient;
